import { useEffect, useRef } from "react";
import { useMyInbox } from "./useMyInbox";

const DELIVERY_KINDS = new Set(["orderShipped", "orderDelivered", "orderCancelled"]);
const SEEN_KEY = "push:seen-ids";
const MAX_SEEN = 500;

function loadSeenIds(): Set<string> {
  try {
    const raw = localStorage.getItem(SEEN_KEY);
    if (!raw) return new Set();
    return new Set(JSON.parse(raw) as string[]);
  } catch {
    return new Set();
  }
}

function persistSeenIds(seen: Set<string>) {
  try {
    const arr = Array.from(seen).slice(-MAX_SEEN);
    localStorage.setItem(SEEN_KEY, JSON.stringify(arr));
  } catch {
    /* storage unavailable (private mode / blocked) — skip persistence */
  }
}

export function useDeliveryPushNotifications(enabled: boolean) {
  const { data } = useMyInbox({ pageSize: 10 }, { refreshInterval: 30_000 });
  const seenRef = useRef<Set<string>>(loadSeenIds());

  useEffect(() => {
    if (!enabled || Notification.permission !== "granted" || !data?.data) return;
    let changed = false;
    for (const n of data.data) {
      if (!DELIVERY_KINDS.has(n.kind) || seenRef.current.has(n.id)) continue;
      new Notification(n.title, { body: n.body ?? undefined, icon: "/favicon.ico" });
      seenRef.current.add(n.id);
      changed = true;
    }
    if (changed) persistSeenIds(seenRef.current);
  }, [data, enabled]);
}
